"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useAuth } from "@/context/ContextProvider";
import { initUtmTracking } from "@/helpers/utmTracking";
import { isNoTrackingRoute } from "@/constants/noTrackingRoutes";

/**
 * Client-Komponente die UTM-Tracking initialisiert.
 * Laeuft bei jedem Seitenaufruf, setzt Cookies aber NUR
 * wenn Analytical-Consent gegeben wurde.
 */
export default function UtmTrackingGate() {
  const pathname = usePathname();
  const blockTracking = isNoTrackingRoute(pathname);
  const { isAnalyticalChecked } = useAuth();

  useEffect(() => {
    if (blockTracking) return;
    if (!isAnalyticalChecked) return;
    initUtmTracking();
  }, [blockTracking, isAnalyticalChecked]);

  return null;
}
